<template>
  <v-form>
    <v-container fluid>
      <v-card elevation="12" class="pa-10">
        <v-row>
          <v-col>
            <h2>Ingrediente Ativo - IRAC</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Sítio Ativo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="sitios"
              v-model="ingrediente.id_sitio"
              item-text="sitio"
              @change="getGruposQuimicos()"
              item-value="id"
              label="Sítio Ativo"
              dense
              outlined
              no-data-text="Adicione um Sítio Ativo para selecionar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Grupo Químico</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="familias"
              v-model="ingrediente.id_familia_quimica"
              item-text="familia_quimica"
              item-value="id"
              label="Grupo Químico"
              dense
              outlined
              no-data-text="Selecione um Sítio Ativo para continuar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Modo de Ação</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="modo_acoes"
              v-model="ingrediente.id_modo_acao"
              item-text="modo_acao"
              item-value="id"
              label="Modo de Ação"
              dense
              outlined
              no-data-text="Adicione um Modo de Ação para selecionar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Ingrediente Ativo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="ingrediente.ingrediente_ativo"
              :rules="fieldRequired"
              label="Ingrediente Ativo"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Imagem (URL)</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              label="Imagem"
              v-model="imagem"
              dense
              outlined
              required
            ></v-text-field>
            <v-img
              :lazy-src="ingrediente.imagem"
              max-height="200"
              max-width="140"
              :src="ingrediente.imagem"
            ></v-img>
            <v-btn
              @click="removerImagem"
              elevation="2"
              class="ml-2 mr-2"
              rounded
              icon
              color="error"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn dark style="margin-left: 5px; margin-top: 2px" color="green" @click="salvar">
              Salvar
            </v-btn>
            <v-btn
              style="margin-left: 5px; margin-top: 2px"
              color="gray"
              to="/irac/ingrediente"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
    >
      {{ aviso }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { BASE_URL } from '../../util/constants';
export default {
  data: () => ({
    url: "https://apiadmin.allgeconsultoria.com/index.php/irac/",
    overlay: false,
    snackbar: false,
    aviso: '',
    sitios: [],
    modo_acoes: [],
    familias: [],
    imagem: '',
    ingrediente: {
      id: "",
      id_sitio: '',
      id_familia_quimica: '',
      id_modo_acao: '',
      ingrediente_ativo: '',
      imagem: ''
    },
    fieldRequired: [(v) => !!v || "Campo Obrigatorio"],
  }),
  created() {
    this.url = `${BASE_URL}irac/`;
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchSitios();
      await this.fetchModoAcoes();

      if (this.$route.params.id !== "" && this.$route.params.id !== undefined) {
        await this.fetchIngrediente(this.$route.params.id);
      }
    },
    async getGruposQuimicos() {
      await this.fetchFamilias(this.ingrediente.id_sitio)
    },
    async fetchSitios() {
      try {
        let response = await fetch(`${this.url}sitio`);
        response = await response.json();
        this.sitios = response.map(item => ({id: item.id, sitio: item.sitio})).filter(familia => familia.sitio !== "").sort((a, b) => a.sitio > b.sitio ? 1 : -1);
      } catch (error) {
        this.sitios = [];
      }
    },
    async fetchFamilias(id_sitio) {
      try {
        let response = await fetch(`${this.url}familia/${id_sitio}/all`);
        response = await response.json();
        this.familias = response.map(item => ({id: item.id, familia_quimica: item.familia_quimica})).filter(familia => familia.familia_quimica !== "").sort((a, b) => a.familia_quimica > b.familia_quimica ? 1 : -1);
      } catch (error) {
        this.familias = [];
      }
    },
    async fetchModoAcoes() {
      try {
        let response = await fetch(`${this.url}modo-acao`);
        response = await response.json();
        this.modo_acoes = response.map(item => ({id: item.id, modo_acao: item.modo_acao})).filter(modo => modo.modo_acao !== "").sort((a, b) => a.modo_acao > b.modo_acao ? 1 : -1);
      } catch (error) {
        this.modo_acoes = [];
      }
    },
    async fetchIngrediente(id) {
      if (id == undefined) return;
      try {
        let response = await fetch(`${this.url}ingrediente/${id}`);
        response = await response.json();
        this.ingrediente = response;
        await this.getGruposQuimicos();
      } catch (error) {
        this.ingrediente = {
          id: "",
          id_sitio: '',
          id_familia_quimica: '',
          id_modo_acao: '',
          ingrediente_ativo: '',
          imagem: ''
        };
      }
    },
    async salvar() {
      this.overlay = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("id_sitio", this.ingrediente.id_sitio);
      urlencoded.append("id_familia_quimica", this.ingrediente.id_familia_quimica);
      urlencoded.append("id_modo_acao", this.ingrediente.id_modo_acao);
      urlencoded.append("ingrediente_ativo", this.ingrediente.ingrediente_ativo);
      urlencoded.append("imagem_is_null", this.imagem === '' ? true : false);
      urlencoded.append("imagem", this.imagem);
      let method = (this.ingrediente.id === '' ? 'POST' : 'PUT')
      
      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: urlencoded,
      };

      fetch(`${this.url}ingrediente/${this.ingrediente.id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          this.overlay = false;
          this.aviso = 'Salvo com Sucesso';
          this.snackbar = true;
          setTimeout(() => this.$router.push(`/irac/ingrediente/`), 1000)
        })
        .catch(error => {
          console.log(error)
          this.overlay = false;
          this.aviso = 'Problema ao Salvar, entre em contato com o suporte';
          this.snackbar = true;
        });
    },
    removerImagem() {
      this.ingrediente.imagem = '';
      this.imagem = '';
    }
  },
};
</script>
